import { Namespace } from '_core/utils/ssr';

export const agencyClaimConfig = {
  i18nNamespaces: ['common', 'agency', 'briefing'] as Namespace,
};
